import { FirebaseApp, deleteApp, initializeApp } from 'firebase/app'
import { Auth, getAuth } from 'firebase/auth';
import { getFirestore, DocumentData, QueryDocumentSnapshot, connectFirestoreEmulator, Firestore } from 'firebase/firestore';
import { connectFunctionsEmulator, Functions, getFunctions } from 'firebase/functions';
import { AppCheck, AppCheckTokenResult, CustomProvider, initializeAppCheck, onTokenChanged } from 'firebase/app-check';

import { environment, resources } from '../tambr.config';
import { settings } from '../store/settings.store';
import packageJson from '../../package.json';

import { Order, OrderData } from '@artask/tambr-models/models/orders.model';
import { PlatformCustomerPaymentMethod, PlatformCustomerPaymentMethodData } from '@artask/tambr-models/models/customer.model';



class FirebaseServiceClass {

  private environment: any;
  public app: FirebaseApp;
  public appCheck: AppCheck;
  public functions: Functions;
  public auth: Auth;
  public firestore: Firestore;
  
  private appCheckCustomProvider = new CustomProvider({
    getToken: async () => {
      try {
        const response = await fetch( this.environment.appCheckTokenUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            businessId: settings.businessId,
            widgetVersion: packageJson?.version ?? null
          })
        });
        const result = await response.json();
        if ( result.success ) {
          return Promise.resolve( result.token );
        } else {
          return Promise.reject( result.error );
        }
      } catch (error) {
        return Promise.reject( error );
      }      
    }
  });


  initApp() {
    this.environment = settings.demo ? resources[settings.demo] : environment;
    this.app = initializeApp( this.environment.firebaseConfig );
    this.appCheck = initializeAppCheck( this.app, { provider: this.appCheckCustomProvider, isTokenAutoRefreshEnabled: true });
    
    onTokenChanged( this.appCheck, 
      ( tokenResult: AppCheckTokenResult ) => {
        console.log( 'onTokenChanged tokenResult', tokenResult );
        settings.appCheckFailed = false;
        settings.appCheckError = null;
      },
      ( error: Error ) => {
        console.log( 'onTokenChanged error', error );
        settings.appCheckFailed = true;
        settings.appCheckError = error.message;
      }
    );

    this.firestore = getFirestore( this.app );
    this.functions = getFunctions( this.app );
    this.auth = getAuth( this.app );

    const emulator = false;
    if ( emulator ) {
      connectFirestoreEmulator( this.firestore, 'localhost', 8080 );
      connectFunctionsEmulator( this.functions, 'localhost', 5001 );
    }
  }

  async deleteApp() {
    await deleteApp( this.app );
  }
}

export const FirebaseService = new FirebaseServiceClass();



export const orderConverter = {
  toFirestore( order: Order ): DocumentData { return order; },
  fromFirestore( doc: QueryDocumentSnapshot<OrderData> ): Order { return { id: doc.id, ...doc.data() }; }
};


export const paymentMethodConverter = {
  toFirestore( paymentMethod: PlatformCustomerPaymentMethodData ): DocumentData {
    return { 
      brand: paymentMethod.brand,
      last4: paymentMethod.last4,
      expMonth: paymentMethod.expMonth,
      expYear: paymentMethod.expYear
    };
  },
  fromFirestore( snapshot: QueryDocumentSnapshot ): PlatformCustomerPaymentMethod {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      brand: data.brand,
      last4: data.last4,
      expMonth: data.expMonth,
      expYear: data.expYear,
      created: data.created
    }
  }
};